import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'
import { useParams } from 'react-router-dom'

const Kandi = () => {
  const { wahlkreisID } = useParams()
  const items = useCubeItems(PageType.KANDI, wahlkreisID)

  return <CubePageTemplate items={items} showPopup />
}

export default Kandi
